export default __webpack_public_path__ + "static/media/property_842.cd1868bd.png";